import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {amsBranchList,} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from '../../../framework.core/JobNames';
import {AmsBranchListItem} from '../../../fms.data/models/AmsBranchListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import _ from "lodash";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';

// function useSelectedOperations() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as AmsBranchListItem;

//   async function create() {
//     const _data = _.cloneDeep(jobListContext.data);
//     if(_data?.find(item => item.isSelected)) {
//       return;
//     }
//     const maxId = _data?.reduce((t, it) => it.id > t ? it.id : t, 0) || 0
//     _data?.unshift({
//       id: maxId + 1,
//       status: '',
//       amsID: '',
//       branch: '',
//       email: '',
//       isSelected: true,
//       isNew: true
//     })
//     jobListContext.setData && jobListContext.setData(_data, _data?.length || 0)
//   }

//   async function remove() {
//     const _data = _.cloneDeep(jobListContext.data);
//     const foundIndex = _data?.findIndex(item => item.isSelected)
//     if(foundIndex === undefined || foundIndex < 0) {
//       return;
//     }
//     _data?.splice(foundIndex, 1);
//     jobListContext.setData && jobListContext.setData(_data, _data?.length || 0)
//   }

//   async function edit() {
//     if (!selectedElement) {
//       return;
//     }
//     const _data = _.cloneDeep(jobListContext.data);
//     if(_data?.find(item => item.isSelected)) {
//       return;
//     }

//     if(_data) {
//       const foundData = _data.find(item => item.id === selectedElement.id);
//       foundData.isSelected = true;
//       jobListContext.setData && jobListContext.setData(_data, _data?.length || 0)
//     }
//   }

//   return {create, edit, remove};
// }

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  // const { view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as OceanQuoteListItem;
  // const appContext = useContext(ApplicationContext);
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  const items = [
    // { label: 'New', shortcut: 'F2', separator: false, newCol: false },
    // { label: 'Edit', shortcut: 'F3', separator: true },
    { label: 'Search', shortcut: 'F5', separator: true, newCol: true },
    { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      // case 0:
      //   view();
      //   break;
      // case 1:
      //   switchToAmsHbl();
      //   break;
      // case 2:
      //   jobListContext.triggerTableSearch('F5');
      //   break;
      // case 3:
      //   switchToAmsMbl();
      //   break;
      // case 4:
      //   jobListContext.reloadData();
      //   break;
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  
  // const selectedElement = jobListContext.selectedElement as AmsBranchListItem;
  // const hasSelectedRow = !!selectedElement;

  // const {edit, create, remove} = useSelectedOperations();

  // return (
  //   <div className="ifms-common-no-vertical-separator">
  //      {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>}
  //       <AddIconButton name='amsBranch-list-add-button' onClick={create} useText iconMode />
  //       <EditIconButton name='amsBranch-list-edit-button' disabled={!hasSelectedRow} onClick={edit} useText/>
  //       <DeleteIconButton name='amsBranch-list-delete-button' disabled={!hasSelectedRow} onClick={remove} useText/>
  //      {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
  //   </div>
  // );
  return null;
}

function ViListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<AmsBranchListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey, onEsc: cancel});

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  function cancel() {
    const _data = _.cloneDeep(jobListContext.data);
    const foundIndex = _data?.findIndex(item => item.isNew)
    if(foundIndex === undefined || foundIndex < 0) {
      return true;
    }
    _data?.splice(foundIndex, 1);
    jobListContext.setData && jobListContext.setData(_data, _data?.length || 0)
    return true;
  }

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS Branch List screen
 *
 * @class BranchListView
 * @extends {AbstractListView}
 */
 class BranchListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSBranch, 'AmsBranchListItem',
    AmsBranchListItem.calculateSearchParameters(search),
    pageNum,
    limit,
    search.pageSize,
    search.pagePerBatch,
    'AMS');

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AMSBranch, 'AmsBranchListItem',
      AmsBranchListItem.calculateSearchParameters(search),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
      'AMS'
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }


  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    
    return AmsBranchListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = amsBranchList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = AmsBranchListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }


  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return `AMS Branch List`;
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  hasMemo(): boolean {
    return false;
  }
};

export default BranchListView;
